// Lead time constraints for appointment scheduling
export const APPOINTMENT_LEAD_TIME_MAX_HOURS = 72;
export const APPOINTMENT_LEAD_TIME_MAX_DAYS = 365;

// Cancellation policy constraints
export const CANCELLATION_POLICY_MAX_HOURS = 24;
export const CANCELLATION_POLICY_MAX_DAYS = 5;

// Default values for cancellation policy rescheduling window
export const CANCELLATION_POLICY_DEFAULT_DURATION = 24;
export const CANCELLATION_POLICY_DEFAULT_TIME_UNIT = 'hours';
